// helpers/axiosInstance.js
import axios from "axios";
import { toast } from "react-toastify";

const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

API.interceptors.request.use((config) => {
    const token = localStorage.getItem("user");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['ngrok-skip-browser-warning'] = 'true';
    return config;
});

// Only force-logout when the JWT is genuinely expired. Transient 401/403s from
// data endpoints used to clear localStorage and bounce the user — that is the
// "portal times out after a while" symptom. Now we check the exp claim before
// wiping the session.
function isJwtExpired(token) {
    if (!token || typeof token !== "string") return false;
    try {
        const parts = token.split(".");
        if (parts.length !== 3) return false;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
        if (!payload.exp) return false;
        return Date.now() >= payload.exp * 1000;
    } catch (_) { return false; }
}

API.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response && error.response.status;
   
        if (status === 401 || status === 403) {
            const token = localStorage.getItem("customer-portal");
            if (isJwtExpired(token )|| status === 403) {
                toast.error("Session expired. Please login again.");
                localStorage.clear();
                window.location.href = "/";
            }
            // Token still valid → bubble the error, do not wipe session.
        }
        return Promise.reject(error);
    }
);

export default API;
